<template>
  <div>
    <!--头部开始 -->
    <top-part></top-part>
    <!-- 头部结束 -->
    <!-- 中间内容开始 -->
    <div class="content-box">
      <div>
        <h1 class="content-title">{{systemData.title}}</h1>
        <div class="text-box" v-html="systemData.content"></div>
      </div>
      <div v-if="noDate">
        <van-empty
          class="custom-image"
          :image="require('../../../assets/images/null@2x.png')"
          description="暂无数据"
        />
      </div>
    </div>
    <!-- 中间内容结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../../components/topPart";
export default {
  components: {
    topPart
  },
  data() {
    return {
      systemData: {}, //页面显示数据
      backEndObj: {}, //后端参数
      backEndInterface: "", //后端地址
      noDate: false //控制暂无数据是否显示
    };
  },
  watch: {},
  mounted() {
    var obj = this.$route.query;
    this.backEndObj = JSON.parse(obj.backEndObj); //保存向后端传递的参数
    this.backEndInterface = obj.backEndInterface; //保存对应接口名称
    this.init();
  },
  methods: {
    // 获取住院制度
    getSystem() {
      this.centralControl.axios.centralControl(
        this.backEndInterface,
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.$set(this.systemData, "title", data.title); //赋值标题
            this.$set(this.systemData, "content", data.content); //赋值内容
          } else {
            this.$message.error(message);
          }
        },
        this.backEndObj
      );
    },
    init() {
      this.getSystem();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/common.styl';

.text-box >>> img {
  width: 100%;
}
.text-box {
  >>> p{
    line-height: 20px;
    font-size: 14px;
  }
}

.content-box {
  myContent();
  background: #fff;
}

.return-text {
  color: #353535;
}

.content-title {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(53, 53, 53, 1);
  line-height: 25px;
  text-align: center;
  margin: 10px;
}

.text-box {
  margin: 10px;
  text-align: left;
  line-height: 18px;

  p {
    font-size: 15px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(53, 53, 53, 1);
    line-height: 25px;
    letter-spacing: 1px;
  }
}
</style>